import React, {Fragment, useRef} from 'react';
import {Form, Field} from 'react-final-form';
import {Popup, Text, Select, Chip_input, Colour_input, Explanation_text} from '../../../components';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import DeleteIcon from '@material-ui/icons/Delete';
import Button from '@material-ui/core/Button';
import ImageIcon from '@material-ui/icons/Image';
import IconButton from '@material-ui/core/IconButton';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { FieldArray } from 'react-final-form-arrays';
import arrayMutators from 'final-form-arrays';
import { connect } from 'react-redux';

function Listing_website_popup(props){
  function onSubmit(params){
    params.company_url_type_id='custom'
    if(params.base_url=='https://www.google.com/search?q=site%3A'){params.base_url=params.base_url+params.domain+'+'; params.url_main_search_parameter='COMPANY_NAME';}
    let result=JSON.parse(JSON.stringify(params));
    if(props.edit_id!=undefined){props.updateWorkspaceListingWebsite(props.edit_id, result);}
    else{props.createWorkspaceListingWebsite(result);}
  }


  let initial_values=undefined;
  let updating=false; if(props.listing_website!=undefined){initial_values=props.listing_website; updating=true;}
  return(
    <Form
      onSubmit={onSubmit}
      initialValues={(initial_values!=undefined)?{...initial_values, parameter_location:(initial_values.parameter_location==undefined)?'URL':initial_values.parameter_location, url_main_search_parameter:(initial_values.url_main_search_parameter==undefined)?"COMPANY_NAME":initial_values.url_main_search_parameter, base_url:(initial_values.base_url==undefined)?'https://www.google.com/search?q=site%3A':initial_values.base_url}:{search_tool:true, url_main_search_parameter:"COMPANY_NAME", base_url:'https://www.google.com/search?q=site%3A', parameter_location:"URL"}}
      mutators={{
        ...arrayMutators
      }}
    >
      {form_props => (
        <form onSubmit={form_props.handleSubmit}>
        <Popup submit_button accept_button='Save' accept_button_click={()=>{form_props.form.submit(); form_props.form.reset(); props.handleClose();}} handleClose={props.handleClose} always_open title={(props.edit_id==undefined)?'workspace_listing_website_create_popup_label':'workspace_listing_website_update_popup_label'} content={
          <div style={{width:'95vw', maxWidth:'600px', minHeight:'300px'}}>
          <div style={{width:'calc(100% - 40px)', marginLeft:'20px', marginTop:'20px'}}>
              <Grid container style={{width:'calc(100% - 20px)', marginLeft:'10px', marginBottom:'0px'}}>
                <Field name='search_on'>{(f_search)=><Field name='company_url_type_id'>{(f)=><Field name='domain'>{(f_domain)=><Field name='name'>{(f_name)=><Field name='base_url'>{(f_base_url)=><Field name='icon'>{(f_icon)=><Field name='description'>{(f_description)=>{
                    return(<Fragment>
                    <Grid item xs={6} sm={6}><div style={{width:'100%', marginTop:'10px'}}><Text  required variant='outlined' color='transparent' title='Name' name='name'/></div></Grid>
                    <Grid item xs={6} sm={6}><div style={{width:'100%', marginTop:'10px'}}><Text disabled={(updating==true)} required variant='outlined' color='transparent' title='Domain' name='domain'/></div></Grid>
                    <Grid item xs={12} sm={12}><div style={{width:'100%', marginTop:'5px', marginBottom:'5px'}}><Text multiline rows={3} variant='outlined' color='transparent' title='Description' name='description'/></div></Grid>
                    <Grid item xs={6} sm={6}><div style={{width:'100%'}}><Text required variant='outlined' color='transparent' title='Search base url' name='base_url'/></div></Grid>
                    <Grid item xs={6} sm={6}><div style={{marginTop:'5px'}}><Select title="Main search parameter" name="url_main_search_parameter" select_data={[{id:"COMPANY_NAME", name:'Company name'}, {id:"COMPANY_DOMAIN", name:"Company domain"}]}/></div></Grid>
                    <Grid item xs={6} sm={6}><div style={{ marginTop: '15px' }}><Select title="Include parameter" name="parameter_location" select_data={[{ id: "URL", name: 'Append to url' }, { id: "CLIPBOARD", name: "Copy to clipboard" }, {id:"URL_CLIPBOARD", name:"Url and clipboard"}]} /></div></Grid>
                    {(f_base_url.input.value!='')?<Grid item xs={12}><div style={{marginLeft:'10px', marginTop:'10px'}}><Field name='search_tool'>{(f)=><FormControlLabel control={<Checkbox checked={f.input.value} onChange={f.input.onChange}/>} label={<Explanation_text inline text="Search url active"/>}/>}</Field></div></Grid>:null}
                  </Fragment>);
                }}</Field>}</Field>}</Field>}</Field>}</Field>}</Field>}</Field>
              </Grid>
          </div>
          </div>
        }/>
        </form>
      )}
    </Form>
  )
}

//<Grid item xs={6}><Grid container><Grid item xs={2}><Field name='icon'>{(f)=><IconButton><img style={{width:'25px'}} src={f.input.value}/></IconButton>}</Field></Grid><Grid item xs={10}><Text disabled={(def!=null && def.id!='custom')} required variant='outlined' color='transparent' title='Icon' name='icon'/></Grid></Grid></Grid>

export default connect(ss, dd)(Listing_website_popup)


function ss(state){
  return{

  }
}

function dd(dispatch){
  return{
    createWorkspaceListingWebsite:(data)=>{console.log(data); dispatch({type:'REQUEST_CREATE_WORKSPACE_LISTING_WEBSITE', payload:data});},
    updateWorkspaceListingWebsite:(id, data)=>{dispatch({type:'REQUEST_UPDATE_WORKSPACE_LISTING_WEBSITE', id:id, payload:data});}
  }
}
